import { PostDto } from '../../../../shared/api';
import { TupleOf } from '../../../../shared/types';
import { clsx } from 'clsx';
import styles from './styles.module.scss';
import { ImageLink } from './image-link';

type Props = {
  className?: string;
  posts: TupleOf<PostDto, 5>;
};

export function Layout5(props: Props) {
  const { posts, className } = props;

  return (
    <div className={clsx(styles['layout-5'], className)}>
      <div className={styles['layout-5__col']}>
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-5__item'], styles['layout-5__item-1'])}
          post={posts[0]}
        />
      </div>
      <div className={styles['layout-5__col']}>
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-5__item'], styles['layout-5__item-2'])}
          post={posts[1]}
        />
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-5__item'], styles['layout-5__item-3'])}
          post={posts[2]}
        />
      </div>
      <div className={styles['layout-5__col']}>
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-5__item'], styles['layout-5__item-4'])}
          post={posts[3]}
        />
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-5__item'], styles['layout-5__item-5'])}
          post={posts[4]}
        />
      </div>
    </div>
  );
}
